export const EnvSelector = {
	env: 'uat'
};